import { SET_PRODUCTS_DATA } from "../actionTypes";
import { Product } from "../../Types/PrismaSwift";

export const setProductsDataAction = (payload: Product[] | []) => {
  return {
    type: SET_PRODUCTS_DATA as typeof SET_PRODUCTS_DATA,
    payload: payload,
  };
};
